import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ lang, meta, title, description, og }) {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            lang
            description
            author
          }
        }
      }
    `
  )

  const htmlLang = lang || site.siteMetadata.lang
  const siteTitle = title || site.siteMetadata.title
  const siteDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang: htmlLang
      }}
      title={siteTitle}
      titleTemplate={`${siteTitle}`}
      meta={[
        {
          name: `description`,
          content: (og && og.description) || siteDescription,
        },
        {
          property: `og:title`,
          content: og && og.title,
        },
        {
          property: `og:description`,
          content: og && og.description,
        },
        {
          property: `og:image`,
          content: og && og.image,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: og && og.title,
        },
        {
          name: `twitter:description`,
          content: og && og.description,
        },
      ].concat(meta)}
    />
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: ``
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default Seo;